import React, { useRef, useEffect, useState } from "react";

const Section = ({ id, label, children, bgClass }) => {
    const ref = useRef();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => setVisible(entry.isIntersecting),
            { threshold: 0.3 }
        );
        if (ref.current) observer.observe(ref.current);
        return () => observer.disconnect();
    }, []);

    return (
        <section ref={ref} id={id} className={`section ${bgClass}`}>
            <div
                className={`section-label top-left ${
                    visible ? "float-down" : ""
                }`}
            >
                {label}
            </div>
            {/* Pass visibility to children */}
            <div className="section-content">
                {typeof children === "function" ? children(visible) : children}
            </div>
        </section>
    );
};

export default Section;
